import type { MoneyScale } from '@shared/money';
import { getOrgMoneyScaleFromStore } from '../../shared/money/orgMoneyScale';

/** Escala monetaria de la org para cobro POS (desde sesión). */
export function getPosCheckoutMoneyScale(): MoneyScale {
  return getOrgMoneyScaleFromStore();
}
